'use client';

import { useEffect, useRef, useState } from 'react';
import { IconInfo } from '@repo/svgs';
import { ModalTrigger } from '@/components/ui/ModalTrigger';
import { InfoPopover } from '@/components/ui/InfoPopover';
import { AboutNycOpenViolationsModal } from '@/components/shared/violations/AboutNycOpenViolationsModal';

export function AboutNycOpenViolationsTrigger() {
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const [isDesktop, setIsDesktop] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const update = () => setIsDesktop(window.innerWidth >= 768);
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  if (!isDesktop) {
    return (
      <ModalTrigger
        label="About open violations"
        content={<AboutNycOpenViolationsModal />}
        urlKey="about-open-violations"
      >
        <IconInfo className="w-4 h-4 icon-primary cursor-pointer" />
      </ModalTrigger>
    );
  }

  return (
    <>
      <button
        ref={anchorRef}
        type="button"
        aria-label="About open violations"
        className="inline-flex"
        onClick={() => setOpen(true)}
      >
        <IconInfo className="w-4 h-4 icon-primary cursor-pointer" />
      </button>
      <InfoPopover
        open={open}
        onOpenChange={setOpen}
        onClose={() => setOpen(false)}
        label="About open violations"
        anchorRef={anchorRef}
        placement="below"
        align="center"
        offsetY={32}
      >
        <AboutNycOpenViolationsModal />
      </InfoPopover>
    </>
  );
}
